import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '@/index';

const baseAppApi = createApi({
  reducerPath: 'api',
  tagTypes: [
    'EMPLOYEE',
    'EMPLOYER',
    'SCHEDULES',
    'SCHEDULES_SUMMARIES',
    'EMPLOYEES',
    'EMPLOYER_REF_INFO',
    'CONTRACTS',
    'ERTNS',
    'ERTN_EMPLOYEES',
    'USERS',
    'PROVINCIAL_LEVIES',
    'LOCAL_LEVIES',
    'UNACCEPTED_BATCHES',
    'NOTIFICATIONS',
    'RECONCILIATION',
    'RETRO_PAY',
    'CACHED_LAST_ACCEPTED',
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: SERVICE_URL,
    prepareHeaders: async (headers) => {
      const token = await getAccessToken();
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
    },
  }),
  endpoints: () => ({}),
});

const API_CACHE_KEYS = {
  SUMMARIZE: 'SUMMARIZE',
  DISCARD_UPLOAD: 'DISCARD_UPLOAD',
};

export { baseAppApi, API_CACHE_KEYS };
